var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditcopy2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.6609 13.7939H9.91569C9.45272 13.7939 9.07617 14.1765 9.07617 14.6468C9.07617 15.118 9.45272 15.4996 9.91569 15.4996H14.6609C15.1239 15.4996 15.5004 15.118 15.5004 14.6468C15.5004 14.1765 15.1239 13.7939 14.6609 13.7939Z",
    fill: "#23273B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.59085 3.75284L11.0874 7.38625C11.1959 7.47315 11.2144 7.6326 11.1297 7.74368L5.79895 14.6898C5.46385 15.1189 4.97001 15.3617 4.4409 15.3706L1.5308 15.4064C1.37559 15.4082 1.23979 15.3007 1.20452 15.1467L0.543129 12.2711C0.428489 11.7426 0.543129 11.1961 0.878232 10.7751L6.23547 3.79584C6.32189 3.68387 6.4815 3.66416 6.59085 3.75284Z",
    fill: "#23273B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.1011 5.2212L12.2342 6.30334C12.1469 6.41352 11.9899 6.43144 11.8815 6.34365C10.8277 5.49084 8.12919 3.30237 7.3805 2.69591C7.27115 2.60633 7.25616 2.44687 7.34435 2.33579L8.18034 1.29755C8.93873 0.321114 10.2615 0.231533 11.3285 1.08255L12.5543 2.05899C13.057 2.45314 13.3921 2.97271 13.5067 3.51916C13.639 4.12025 13.4979 4.71059 13.1011 5.2212Z",
    fill: "#23273B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditcopy2);
export default __webpack_public_path__ + "static/media/Edit copy 2.bc7bbbed504d1add070a399a19592d0a.svg";
export { ForwardRef as ReactComponent };